export const encodeUri = (uri: string) => (uri ? window.encodeURIComponent(uri) : '');

export const capitalize = (word: string) =>
  word.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase());

export const replaceStringPlaceholders = (text: string, values: string[]) =>
  text.replace(/\$(\d)/g, (_, p1) => values[p1 - 1] || '');

export const decodeHTMLEntities = (text: string): string => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;

  return textArea.value;
};

export const focusHandler = (elementClass: string): void => {
  const inputElement = <HTMLInputElement>document.querySelector(elementClass);
  if (inputElement) {
    inputElement.focus();
  }
}

export const pageShowListener = (callback: Function): void => {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      callback();
    }
  });
}

export const isValidEmail = (email: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.toLowerCase())

export const getHtmlElementByClass = (className: string): HTMLElement =>
  <HTMLElement>document.querySelector(`.${className}`);

export const getScrollPercentage = (): number =>
  Math.round(window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100);

export const footerCheckFixable = (): void => {
  setTimeout(() => {
    const footer = document.getElementById('footer');

    if (footer && window.innerHeight > footer.getBoundingClientRect().bottom + 50) {
      footer.classList.add('fixed');
    }
  });
}